module.exports = __webpack_public_path__ + "img/pro-zdTicon13.8bdca126.png";